import API from '@/api/business'
import {getList} from '@/utils/index'

const global = {
    state: {
        company: null,
    },
    
    mutations: {
        SET_COMPANY: (state, company) => {
            state.company = company
        },
        SET_DEP: (state, departmentTree) => {
            state.departmentTree = departmentTree
        },
    },
    
    actions: {
        
        GetCompany({commit,state}) {
            return new Promise((resolve, reject) => {
                if(state.company){
                    resolve(state.company)
                }else {
                    API.departmentTreeData().then(res => {
                        
                        if (res) {
                            if (res.length !== 0) {
                                getList(res);
                            }
                            commit('SET_COMPANY', res);
                            resolve(res)
                        } else {
                            reject(res)
                        }
                    }).catch(err => {
                        reject(err)
                    })
                }
            })
        },

        GetDep({commit,state},id) {
            return new Promise((resolve, reject) => {
                API.getDepTreeByRoot({id:id}).then(res => {
                    
                    if (res) {
                        state.id = res;
                        resolve(res)
                    } else {
                        reject(res)
                    }
                }).catch(err => {
                    reject(err)
                })
            })
        },
    }
};

export default global
